import { usePriceIntent } from '@/features/priceCalculator/usePriceIntent'
import { useShopSessionCustomer } from '@/features/priceCalculator/useShopSessionCustomer'
import { Features } from '@/utils/Features'
import { useFormatter } from '@/utils/useFormatter'
import { FetchInsurance } from './FetchInsurance'

const REGISTRATION_NUMBER_FIELD = 'registrationNumber'

export function FetchInsuranceContainer() {
  const shopSessionCustomer = useShopSessionCustomer()
  const { priceIntent } = usePriceIntent()
  const formatter = useFormatter()

  if (!priceIntent) {
    return null
  }

  if (!Features.enabled('INSURELY')) return null
  if (!priceIntent.externalInsurer) return null
  if (!priceIntent.insurely) return null

  // At the moment, we show exposure only for car insurance
  const registrationNumber = priceIntent.data[REGISTRATION_NUMBER_FIELD] as string | undefined
  const formattedRegistrationNumber = registrationNumber
    ? formatter.carRegistrationNumber(registrationNumber)
    : undefined

  return (
    <FetchInsurance
      priceIntentId={priceIntent.id}
      customerSsn={shopSessionCustomer?.ssn ?? undefined}
      externalInsurer={priceIntent.externalInsurer}
      insurely={priceIntent.insurely}
      productName={priceIntent.product.displayNameFull}
      exposure={formattedRegistrationNumber}
    />
  )
}
